import { Location } from '@angular/common';
import { PerfilesService } from './../../services/perfiles.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.css']
})
export class PerfilComponent implements OnInit {

  @ViewChild("mensaje") mensaje:ElementRef;
  codigo;
  perfil:{}={};
  permisos;
  constructor(private activatedRoute:ActivatedRoute, private perfilesService:PerfilesService, 
  private location:Location, private renderer:Renderer2) {
    this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];
      
    });

    if(this.codigo!="nuevo"){
      this.cargarPerfil();
    }else{
      this.perfil={};
    }
  }

  ngOnInit() {
    
  }

  cargarPerfil(){
    this.perfilesService.getPerfil(this.codigo).subscribe(resp=>{
      
      this.perfil=resp["perfil"];
      if(this.perfil["PEadmin"]==1){
        this.permisos="admin";
      }else if(this.perfil["PEinterviniente"]==1){
        this.permisos="interviniente";
      }else{
        this.permisos="usuario";
      }
    });
  }

  guardarPerfil(){
    
    if(this.codigo=="nuevo"){
      this.insertarPerfil();
    }else{
      this.actualizarPerfil();
    }
  }

  mostrarPermiso(){
    
  }

  insertarPerfil(){
    this.cambiarPermisosPerfil();
    this.perfilesService.insertarPerfil(this.perfil)
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["msg"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);

      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }

      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 2000);
    });
  }

  actualizarPerfil(){
    this.cambiarPermisosPerfil();
    this.perfilesService.actualizarPerfil(this.perfil)
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["msg"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);

      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }

      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 2000);
    });
  }

  cambiarPermisosPerfil(){
    switch(this.permisos){
      case "usuario":
        this.perfil["PEusuario"]=1;
        this.perfil["PEinterviniente"]=0;
        this.perfil["PEadmin"]=0;
      break;
      case "interviniente":
        this.perfil["PEusuario"]=0;
        this.perfil["PEinterviniente"]=1;
        this.perfil["PEadmin"]=0;
      break;
      case "admin":
        this.perfil["PEusuario"]=0;
        this.perfil["PEinterviniente"]=0;
        this.perfil["PEadmin"]=1;
      break;
    }
  }

  volver(){
    this.location.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/perfil/perfil.component.ts